<!-- FAD MASIVO DESKTOP -->
<div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
    <div class="create-account-container">
        <br>
        <form class="form" *ngIf="!userData">
            <div class="mensaje">
                <p>Si ya eres usuario de FAD</p>
                <div class="edit-btn">
                    <button mat-raised-button [routerLink]="['/inicia-sesion']" class="white-button">
                        INICIA SESIÓN
                    </button>
                </div>
                <p>O <a (click)="createAccount()">crea tu cuenta</a> con 3 firmas gratis al mes.</p>
            </div>
        </form>

        <div class="account-created" *ngIf="userData">
            <div class="item">
                <div class="info">
                    <p class="title">Usuario</p>
                    <p>{{userData?.user}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Nombre</p>
                    <p>{{userData?.name}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Apellido</p>
                    <p>{{userData?.lastName}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Correo electrónico</p>
                    <p>{{userData?.email}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>
        </div>
        <div class="disabled" *ngIf="!active"></div>
    </div>

</div>

<!-- FAD MASIVO RESPONSIVO -->
<div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">

    <form class="form" *ngIf="!userData">
        <div class="mensaje">
            <p>Si ya eres usuario de FAD</p>
            <div class="edit-btn">
                <button mat-raised-button [routerLink]="['/inicia-sesion']" class="blanco-button">
                    INICIA SESIÓN
                </button>
            </div>
            <p>O <a (click)="createAccount()">crea tu cuenta</a> con 3 firmas gratis al mes.</p>
        </div>
    </form>

    <div class="account-created" *ngIf="userData">
        <div class="item">
            <div class="info">
                <p class="title">Usuario</p>
                <p>{{userData?.user}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Nombre</p>
                <p>{{userData?.name}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Apellido</p>
                <p>{{userData?.lastName}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Correo electrónico</p>
                <p>{{userData?.email}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>
    </div>
    <div class="disabled" *ngIf="!active"></div>

</div>
